import type { RefObject } from 'react'

import type { BlogPostCustom } from '@twisto/api-cms'

import { Post } from '../post'

import * as styles from './posts-list.styles'

export const PostsList = ({
  posts,
  containerRef,
}: {
  posts: BlogPostCustom[]
  containerRef: RefObject<HTMLDivElement>
}) => (
  <div ref={containerRef} css={styles.list}>
    {posts.map((post) => (
      <Post key={post.id} listItem {...post} />
    ))}
  </div>
)
